import type { MenuItemProps } from './MenuItem';

export const getActiveMenu = (pathname: string, items: MenuItemProps[]) => {
  const index = items.findIndex((mi) => pathname.startsWith(mi.route));
  const item = index >= 0 ? items[index] : undefined;
  return {
    index,
    route: item?.route ?? '',
  };
};
